module.exports = __webpack_public_path__ + "static/media/check-circle-24px-completed.d5bd59fd.svg";